import React, { useState, useRef, useEffect } from 'react';
import './index.scss';
import LEIcon from '../../assets/le02.svg';
import AEIcon from '../../assets/ae02.svg';
import PEIcon from '../../assets/pe02.svg';
import PCIcon from '../../assets/PC1.svg';
import SSButton from '../SSButton';
import PopUpContainer from '../PopUpContainer';
import PCInstall from '../PCInstall';
import { DOMAIN } from '../../Constants/base';
import { getReq } from '../../utils/api';
import { postLogger } from '../../utils/analytics';
import { getSessionStorage } from '../../utils';
import LoadingSpin from '../LoadingSpin';

function InstallApps() {
  const profiles = getSessionStorage('current-profile');
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales'));

  const [openPCPopup, setOpenPCPopup] = useState(false);
  const [products, setProducts] = useState([]);
  const [plan, setPlan] = useState({
    product: {
      nickName: 'PC',
    },
  });
  const [isLoading, setIsLoading] = useState(false);

  const getAppDetails = async () => {
    setIsLoading(true);
    let url = `${DOMAIN}/v1/stripe/user/subscriptions`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };

    const response = await getReq({ url, requestHeaders });
    const { code, data } = response;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      setProducts(data.subscriptions);
    } else if (timeoutCode === '5') {
      let newPayload = {
        ...profiles,
        code,
      };

      postLogger('GET_PLANS', newPayload);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAppDetails();
  }, []);

  const getIcon = (nickName) => {
    if (nickName === 'LEAD_ENGAGER') return LEIcon;
    if (nickName === 'AUDIENCE_ENGAGER') return AEIcon;
    if (nickName === 'PRO_EMAILER') return PEIcon;
    if (nickName === 'PRO_CALLER') return PCIcon;
  };

  const handleAppClick = (nickName) => () => {
    if (nickName === 'PRO_CALLER') {
      setOpenPCPopup(true);
      setPlan({
        product: {
          nickName: 'PRO_CALLER',
        },
      });
    }
    if (nickName === 'PRO_EMAILER') {
      setOpenPCPopup(true);
      setPlan({
        product: {
          nickName: 'PRO_EMAILER',
        },
      });
    }
    if (nickName === 'AUDIENCE_ENGAGER') {
      window.open(
        'https://chrome.google.com/webstore/detail/sales-stack-audience-enga/jgiapobaigghdocinfndjifhkcnmbcan',
        '_blank'
      );
    }
    if (nickName === 'LEAD_ENGAGER') {
      window.open(
        'https://chrome.google.com/webstore/detail/sales-stack-lead-engager/opcgffjclpcoeiajgachmeecapgldmcl',
        '_blank'
      );
    }
  };

  return (
    <div className="install-sub-container">
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <LoadingSpin />
        </div>
      ) : (
        <div
          className="sub-buy-container"
          style={{
            border: 'none',
          }}
        >
          <div
            className="subscriptions"
            style={{
              width: '100%',
            }}
          >
            <div className="active-subscriptions">
              {products.map((item, index) => {
                if (item.product.nickName === 'STACK_BUNDLE') return null;
                return (
                  <div key={index} className="active-plan">
                    <div className="tool" style={{ width: '80%' }}>
                      <div className="icon">
                        <img src={getIcon(item.product.nickName)} alt="" />
                      </div>
                      <div className="details">
                        <div className="tool-name">{item.product.name}</div>

                        <div className="tool-desc">{item.product.description}</div>
                      </div>
                      <div className="ss-cta">
                        <SSButton
                          type="filled"
                          btnText={'Install'}
                          onClickHandle={handleAppClick(item.product.nickName)}
                        />
                      </div>
                    </div>
                    <div className="tool-more" style={{ justifyContent: 'flex-end' }}>
                      <SSButton
                        type="filled"
                        btnText={'Install'}
                        onClickHandle={handleAppClick(item.product.nickName)}
                      />
                    </div>
                    <div className="mob-details">
                      <div className="tool-name">{item.product.name}</div>
                      <div className="tool-desc">{item.product.description}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {openPCPopup && (
        <PopUpContainer>
          <PCInstall
            setOpenPopUp={setOpenPCPopup}
            plan={plan}
            roleType={'OWNER'}
            isActive={true}
            isSBActivated={true}
          />
        </PopUpContainer>
      )}
    </div>
  );
}

export default InstallApps;
